<template>
  <div class="tab-pane fade show active">
    <div class="card">
      <div
        class="card-header d-flex justify-content-between align-items-center"
      >
        <div>
          <h5 class="mb-0">EAC Trade History & Analysis</h5>
          <small class="text-muted"
            >Historical trade volumes and market activity</small
          >
        </div>
      </div>
      <div class="card-body">
        <EacTradeHistoryComponent />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import EacTradeHistoryComponent from "@/market_insights/admin/EacTradeHistoryComponent.vue";
</script>
